import { useBreakpointValue } from "@chakra-ui/react";

export const useBreakPoint = () => {
  const isMobile = useBreakpointValue({ base: true, md: false });
  const isTablet = useBreakpointValue({ base: true, lg: false });
  return { isMobile, isTablet };
};
